import { defineComponent, ref, watchEffect } from 'vue'
import useVideoState from '@/composables/use-video-state'
import useBreakpoints from '@/composables/use-breakpoints'
import { useMounted } from '@vueuse/core'
import { timeline } from 'motion'

export default defineComponent({
    setup(props) {
        const video = ref(/** @type {HTMLVideoElement?} */ (null))
        const phrases = ref(/** @type {(HTMLHeadingElement | HTMLSpanElement)[]} */ ([]))
        const breakpoints = useBreakpoints()
        const isXl = breakpoints.greaterOrEqual('xl')
        const { isReady: isVideoReady, isPlaying: isVideoPlaying } = useVideoState(video)
        const isMounted = useMounted()
        const animation = ref(/** @type {import('motion').AnimationControls?}) */ (null))

        watchEffect((onCleanup) => {
            if (!isMounted.value || !isVideoReady.value) return

            animation.value = timeline(phrases.value.flatMap((phrase) => [
                [phrase, { opacity: [0, 1], y: ['10%', '0%'] }, { duration: props.duration, at: '-0.5' }],
                [phrase, { opacity: 0 }, { duration: 1.5, at: '+0.5' }]
            ]), {
                defaultOptions: { easing: [0.16, 1, 0.3, 1] /* ease out expo */ },
                repeat: Infinity
            })
            onCleanup(() => animation.value?.cancel())
        })

        watchEffect(() => {
            animation.value?.[isVideoPlaying.value ? 'play' : 'pause']()
        })

        return {
            video,
            phrases,
            isXl,
            isVideoReady,
            isVideoPlaying
        }
    },
    props: {
        duration: Number
    }
})